export enum OnboardingStepTypeModel {
  Navigate = 1,
  Action = 2
}